"use strict";

exports.__esModule = true;
exports.default = void 0;
function NoopWrapper(props) {
  return props.children;
}
var _default = NoopWrapper;
exports.default = _default;
module.exports = exports["default"];